// import { useState, useEffect } from "react";
// import { observer } from "mobx-react";
// import { useNavigate, Link, useLocation } from "react-router-dom";
// import { routeMapping } from "../tiles";
// import useStore from "../../hooks/useStore";
// import menuIcon from "../../assets/images/logo-icon.png";
// import { toJS } from "mobx";

// function Sidebar() {
//   const navigate = useNavigate();
//   const {
//     companyStore: { subCategoryList, setSubCatId, setKpiId, subCatId, catId },
//     userStore: { isLoggedIn, isAdminLoggedIn, userData },
//   } = useStore();
//   const [toggleSubCatId, setToggleSubCatId] = useState("");
//   const subCatList = toJS(subCategoryList);
//   const pathName = useLocation().pathname;

//   //console.log("subCatList", subCatList);

//   useEffect(() => {
//     setToggleSubCatId(subCatId);
//   }, [subCatId]);

//   if (isLoggedIn) {
//     return (
//       <>
//         <div className="vertical-menu">
//           <div data-simplebar className="h-100 scrolling-sidebar">
//             <div id="sidebar-menu">
//               <ul className="metismenu list-unstyled" id="side-menu">
//                 <li className="menu-title" key="t-menu">
//                   Menu
//                 </li>

//                 {isLoggedIn && (
//                   <>
//                     {subCatList?.length > 0 &&
//                       subCatList?.map((subCategory, subCatIndex) => (
//                         <li key={subCategory.id}>
//                           <button
//                             onClick={() => {
//                               setToggleSubCatId((prev) =>
//                                 prev ? null : subCategory.subCatId
//                               );
//                               setSubCatId(subCategory.subCatId);
//                             }}
//                           >
//                             <img src={menuIcon} alt="" />{" "}
//                             {subCategory.subCatIdAssignSubCategory.name}
//                             <i
//                               className={
//                                 toggleSubCatId === subCategory.subCatId &&
//                                 subCategory.kpi.length > 0
//                                   ? "mdi mdi-chevron-up"
//                                   : "mdi mdi-chevron-down"
//                               }
//                             ></i>
//                           </button>

//                           {/* {toggleSubCatId === subCategory.subCatId &&
//                             subCategory.kpi.length > 0 && (
//                               <ul className={`kpi-menu  `}>
//                                 {subCategory.kpi.map((kpi) => (
//                                   <li
//                                     className={
//                                       pathName ===
//                                       `/company/${kpi.kpiIdAssignKpi.slug}`
//                                         ? "sidebar-active"
//                                         : ""
//                                     }
//                                     onClick={() => {
//                                       navigate(
//                                         `/company/${kpi.kpiIdAssignKpi.slug}`
//                                       );
//                                       setKpiId(kpi.kpiId);
//                                     }}
//                                     key={kpi.id}
//                                   >
//                                     View {kpi.kpiIdAssignKpi.name}
//                                   </li>
//                                 ))}
//                               </ul>
//                             )} */}
//                            {toggleSubCatId === subCategory.subCatId &&
//   subCategory.kpi.length > 0 && (
//     <ul className="kpi-menu">
//       {subCategory.kpi.map((kpi) => (
//         <li
//           className={
//             pathName === `/company/${kpi.kpiIdAssignKpi.slug}`
//               ? "sidebar-active"
//               : ""
//           }
//           onClick={() => {
//             navigate(`/company/${kpi.kpiIdAssignKpi.slug}`);
//             setKpiId(kpi.kpiId);
//           }}
//           key={kpi.id}
//         >
//           View {kpi.kpiIdAssignKpi.name}
//         </li>
//       ))}
//       {/* {subCategory.kpi.map((kpi) => {
//         const slug = kpi.kpiIdAssignKpi.slug;
//         if (slug === "water") {
//           return (
//             <li
//               onClick={() => {
//                 navigate(`/company/add-${slug}`);
//                 setKpiId(kpi.kpiId);
//               }}
//               key={`add-${kpi.id}`}
//             >
//               Add {kpi.kpiIdAssignKpi.name}
//             </li>
//           );
//         } else if (slug === "waste") {
//           return (
//             <li
//               onClick={() => {
//                 navigate(`/company/${slug}/add-${slug}`);
//                 setKpiId(kpi.kpiId);
//               }}
//               key={`add-${kpi.id}`}
//             >
//               Add {kpi.kpiIdAssignKpi.name}
//             </li>
//           );
//         } else if (
//           slug === "waste" ||
//           slug === "energy" ||
//           slug === "aqi" ||
//           slug === "biodiversity"
//         ) {
//           return (
//             <li
//               onClick={() => {
//                 navigate(`/company/${slug}/add`);
//                 setKpiId(kpi.kpiId);
//               }}
//               key={`add-${kpi.id}`}
//             >
//               Add {kpi.kpiIdAssignKpi.name}
//             </li>
//           );
//         }
//         // else: do not show "Add"
//         return null;
//       })} */}
//     </ul>
//   )
// }
//                         </li>
//                       ))}

//                       {userData?.role === "company" && catId === "1" && (
//                       <li
//                         onClick={() => {
//                           navigate("/company/totalProduction");
//                         }}
//                       >
//                         <button>
//                           <img src={menuIcon} alt="" /> Total Production
//                         </button>
//                       </li>
//                     )}

//                     {userData?.department !== "User" && catId === "2" && (
//                       <li
//                         to="/company/revenue"
//                         onClick={() => {
//                           navigate("/company/revenue");
//                         }}
//                       >
//                         <button>
//                           <img src={menuIcon} alt="" /> Revenue
//                         </button>
//                       </li>
//                     )}
//                     {userData?.department !== "User" && (
//                       <>
//                         <li
//                           to="/company/employee"
//                           onClick={() => {
//                             navigate("/company/employee");
//                           }}
//                         >
//                           <button>
//                             <img src={menuIcon} alt="" /> Employee
//                           </button>
//                         </li>
//                         <li
//                           to="/company/"
//                           onClick={() => {
//                             navigate("/company/setKpiTarget");
//                           }}
//                         >
//                           <button>
//                             <img src={menuIcon} alt="" />
//                             Set Kpi Target
//                           </button>
//                         </li>
//                         <li
//                           to="/company/"
//                           onClick={() => {
//                             navigate("/company/logList");
//                           }}
//                         >
//                           <button>
//                             <img src={menuIcon} alt="" />
//                             Activity Log
//                           </button>
//                         </li>
//                       </>
//                     )}
//                     {/* {userData?.role === "company" && (
//                       <li
//                        to="/company/"
//                         onClick={() => {
//                           navigate("/company/scorecard");
//                         }}
//                       >
//                         <button>
//                           <img src={menuIcon} alt="" /> Scorecard Data
//                         </button>
//                       </li>
//                     )} */}

//                   </>
//                 )}
//                 {isAdminLoggedIn && (
//                   <>
//                     {Object.entries(routeMapping).map(([key, value]) =>
//                       key === "Assign" ? null : (
//                         <li
//                           key={key}
//                           onClick={() => {
//                             navigate(value.path);
//                           }}
//                           style={{ cursor: "pointer" }}
//                         >
//                           <span>{value.icon}</span>
//                           {key}
//                         </li>
//                       )
//                     )}
//                   </>
//                 )}
//               </ul>
//             </div>
//           </div>
//         </div>
//       </>
//     );
//   }
//   return (
//     <div className="vertical-menu">
//       <div data-simplebar className="h-100">
//         <div id="sidebar-menu">
//           <ul className="metismenu list-unstyled" id="side-menu">
//             <li className="menu-title">Menu</li>

//             {/* <li className={`${openMenus["dashboards"] ? "menu-open" : ""}`}>
//               <Link
//                 className="has-arrow waves-effect"
//                 onClick={() => toggleMenu("dashboards")}
//               >
//                 <i className="bx bx-home-circle"></i>
//                 <span key="t-dashboards">Dashboards</span>
//               </Link>
//               <ul className="sub-menu">
//                 <li>
//                   <Link to="/admin">Default</Link>
//                 </li>
//                 <li>
//                   <Link to="/admin/categories">Category</Link>
//                 </li>
//                 <li>
//                   <Link to="/admin/company">Companies</Link>
//                 </li>
//                 <li>
//                   <Link to="/admin/unit">Unit</Link>
//                 </li>
//                 <li>
//                   <Link to="/admin/water">Water</Link>
//                 </li>
//               </ul>
//             </li> */}

//             <li>
//               <Link to="/admin/dashboard" className="waves-effect">
//                 <i className="bx bx-home-circle"></i>
//                 <span>Dashboard</span>
//               </Link>
//             </li>

//             <li>
//               <Link to="/admin/categories" className="waves-effect">
//                 <i className="bx bx-detail"></i>
//                 <span>Category</span>
//               </Link>
//             </li>

//             <li>
//               <Link to="/admin/subcategories" className="waves-effect">
//                 <i className="bx bx-file"></i>
//                 <span>Sub Category</span>
//               </Link>
//             </li>

//             <li>
//               <Link to="/admin/kpi" className="waves-effect">
//                 <i className="bx bx-receipt"></i>
//                 <span>KPI</span>
//               </Link>
//             </li>

//             {/* <li>
//               <Link to="/admin/fields" className="waves-effect">
//                 <i className="bx bx-calendar"></i>
//                 <span>Fields</span>
//               </Link>
//             </li> */}

//             {/* <li>
//               <Link to="/admin/unit" className="waves-effect">
//                 <i className="bx bx-task"></i>
//                 <span>Unit</span>
//               </Link>
//             </li> */}

//             <li>
//               <Link to="/admin/company" className="waves-effect">
//                 <i className="bx bx-store"></i>
//                 <span>Companies</span>
//               </Link>
//             </li>
//           </ul>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default observer(Sidebar);


import React, { Fragment } from "react";
import { useState, useEffect } from "react";
import { observer } from "mobx-react";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { routeMapping } from "../tiles";
import useStore from "../../hooks/useStore";
import menuIcon from "../../assets/images/logo-icon.png";
import { toJS } from "mobx";
import { useAuth } from "../../context/authProvider"; // Add this import

function Sidebar() {
  const navigate = useNavigate();
  const { dashboardTab } = useAuth(); // Add this to get current dashboard tab
  const {
    companyStore: { subCategoryList, setSubCatId, setKpiId, subCatId, catId },
    userStore: { isLoggedIn, isAdminLoggedIn, userData },
    formStore
  } = useStore();
  const [toggleSubCatId, setToggleSubCatId] = useState("");
  const subCatList = toJS(subCategoryList);
  const pathName = useLocation().pathname;

  useEffect(() => {
    setToggleSubCatId(subCatId);
  }, [subCatId]);

  console.log("Current Dashboard Tab:", dashboardTab); // Debugging line

  // Default state for Add KPI navigation
  const defaultKpiState = {
    formData: {},
    groupsFilled: [],
    freq: {},
    formid: "",
    unitGlobal: ""
  };

  const handleAddKpi = (kpiId, kpiType) => {
    formStore.reset(); // Clear previous KPI data
    setKpiId(kpiId);   // Set the new KPI ID in the store
    formStore.fetchFields(); // Fetch fields for the new KPI
    navigate(`/company/${kpiType}/add`, { state: defaultKpiState });
  };


  // Function to render ESG/Home dashboard specific menu
  const renderESGMenu = () => (
    <>
      <li className="menu-title" key="t-dashboard-menu">
        Dashboard Menu
      </li>

      
      {/* Employee Management */}

       
        
        <li
          className={pathName === "/company/dashboard" ? "sidebar-active" : ""}
          onClick={() => navigate("/company/dashboard")}
        >
          <button>
            <img src={menuIcon} alt="" /> Home
          </button>
        </li>
    
      {userData?.department !== "User" && (
        
        <li
          className={pathName === "/company/employee" ? "sidebar-active" : ""}
          onClick={() => navigate("/company/employee")}
        >
          <button>
            <img src={menuIcon} alt="" /> Employee Management
          </button>
        </li>
      )}

      {/* Revenue */}
      {userData?.department !== "User" && (
        <li
          className={pathName === "/company/revenue" ? "sidebar-active" : ""}
          onClick={() => navigate("/company/revenue")}
        >
          <button>
            <img src={menuIcon} alt="" /> Revenue
          </button>
        </li>
      )}

      {/* ESG Scorecard */}
      {userData?.role === "company" && (
        <li
          className={pathName === "/company/scorecard" ? "sidebar-active" : ""}
          onClick={() => navigate("/company/scorecard")}
        >
          <button>
            <img src={menuIcon} alt="" /> ESG Scorecard
          </button>
        </li>
      )}

      {/* Set KPI Target */}
      {userData?.department !== "User" && (
        <li
          className={pathName === "/company/setKpiTarget" ? "sidebar-active" : ""}
          onClick={() => navigate("/company/setKpiTarget")}
        >
          <button>
            <img src={menuIcon} alt="" /> Set KPI Target
          </button>
        </li>
      )}

      {/* Activity Log */}
      {userData?.department !== "User" && (
        <li
          className={pathName === "/company/logList" ? "sidebar-active" : ""}
          onClick={() => navigate("/company/logList")}
        >
          <button>
            <img src={menuIcon} alt="" /> Activity Log
          </button>
        </li>
      )}
    </>
  );

  // Function to render category-specific menu (existing logic)
  const renderCategoryMenu = () => (
    <>
      <li className="menu-title" key="t-menu">
        Menu
      </li>

       
        
        <li
          className={pathName === "/company/dashboard" ? "sidebar-active" : ""}
          onClick={() => navigate("/company/dashboard")}
        >
          <button>
            <img src={menuIcon} alt="" /> Home
          </button>
        </li>
    

      {subCatList?.length > 0 &&
        subCatList?.map((subCategory, subCatIndex) => (
          <li key={subCategory.id}>
            <button
              onClick={() => {
                setToggleSubCatId((prev) =>
                  prev ? null : subCategory.subCatId
                );
                setSubCatId(subCategory.subCatId);
              }}
            >
              <img src={menuIcon} alt="" />{" "}
              {subCategory.subCatIdAssignSubCategory.name}
              <i
                className={
                  toggleSubCatId === subCategory.subCatId &&
                  subCategory.kpi.length > 0
                    ? "mdi mdi-chevron-up"
                    : "mdi mdi-chevron-down"
                }
              ></i>
            </button>

            {/* {toggleSubCatId === subCategory.subCatId &&
              subCategory.kpi.length > 0 && (
                <ul className="kpi-menu">
                  {subCategory.kpi.map((kpi) => (
                    <>
                      <li
                        className={
                          pathName === `/company/${kpi.kpiIdAssignKpi.slug}`
                            ? "sidebar-active"
                            : ""
                        }
                        onClick={() => {
                          navigate(`/company/${kpi.kpiIdAssignKpi.slug}`);
                          setKpiId(kpi.kpiId);
                        }}
                        key={`view-${kpi.id}`}
                      >
                        View {kpi.kpiIdAssignKpi.name}
                      </li>
                      {/* Add logic for Add {kpi.kpiIdAssignKpi.name} 
                      {(() => {
                        const name = kpi.kpiIdAssignKpi.name?.toLowerCase();
                        let route = "";
                        let kpiType = name;
                        if (name === "water") {
                          route = "/company/add-water";
                          kpiType = "add-water";
                        } else if (name === "waste") {
                          route = "/company/waste/add-waste";
                          kpiType = "waste/add-waste";
                        } else if (["energy", "emission", "biodiversity"].includes(name)) {
                          // emission uses 'aqi' as route name
                          const routeName = name === "emission" ? "aqi" : name;
                          route = `/company/${routeName}/add`;
                          kpiType = routeName;
                        } else {
                          return null;
                        }
                        return (
                          <li key={`add-${kpi.id}`}>
                            <button onClick={() => {
                              handleAddKpi(kpi.kpiId, kpiType);
                              navigate(route);
                            }}>
                              Add {kpi.kpiIdAssignKpi.name}
                            </button>
                          </li>
                        );
                      })()}
                    </>
                  ))}
                </ul>
              )} */}
              {toggleSubCatId === subCategory.subCatId &&
  subCategory.kpi.length > 0 && (
    <ul className="kpi-menu">
      {subCategory.kpi.map((kpi) => (
        <React.Fragment key={kpi.id}>
          {/* View KPI Item */}
          <li
            className={
              pathName === `/company/${kpi.kpiIdAssignKpi.slug}`
                ? "sidebar-active"
                : ""
            }
            onClick={() => {
              navigate(`/company/${kpi.kpiIdAssignKpi.slug}`);
              setKpiId(kpi.kpiId);
            }}
          >
            View {kpi.kpiIdAssignKpi.name}
          </li>
          
          {/* Add KPI Item */}
          {(() => {
            const name = kpi.kpiIdAssignKpi.name?.toLowerCase();
            let route = "";
            let kpiType = name;
            
            if (name === "water") {
              route = "/company/add-water";
              kpiType = "add-water";
            } else if (name === "waste") {
              route = "/company/waste/add-waste";
              kpiType = "waste/add-waste";
            } else if (["energy", "emission", "biodiversity"].includes(name)) {
              const routeName = name === "emission" ? "aqi" : name;
              route = `/company/${routeName}/add`;
              kpiType = routeName;
            } else {
              return null;
            }
            
            return (
              <li
                onClick={() => {
                  handleAddKpi(kpi.kpiId, kpiType);
                  navigate(route);
                }}
              >
                Add {kpi.kpiIdAssignKpi.name}
              </li>
            );
          })()}
        </React.Fragment>
      ))}
    </ul>
  )}
          </li>
        ))}

      {userData?.role === "company" && catId === "1" && (
        <li
          onClick={() => {
            navigate("/company/totalProduction");
          }}
        >
          <button>
            <img src={menuIcon} alt="" /> Total Production
          </button>
        </li>
      )}

      {userData?.department !== "User" && catId === "2" && (
        <li
          onClick={() => {
            navigate("/company/revenue");
          }}
        >
          <button>
            <img src={menuIcon} alt="" /> Revenue
          </button>
        </li>
      )}

      {userData?.department !== "User" && (
        <>
          <li
            onClick={() => {
              navigate("/company/employee");
            }}
          >
            <button>
              <img src={menuIcon} alt="" /> Employee
            </button>
          </li>
          <li
            onClick={() => {
              navigate("/company/setKpiTarget");
            }}
          >
            <button>
              <img src={menuIcon} alt="" />
              Set Kpi Target
            </button>
          </li>
          <li
            onClick={() => {
              navigate("/company/logList");
            }}
          >
            <button>
              <img src={menuIcon} alt="" />
              Activity Log
            </button>
          </li>
        </>
      )}
    </>
  );

  if (isLoggedIn) {
    return (
      <>
        <div className="vertical-menu">
          <div data-simplebar className="h-100 scrolling-sidebar">
            <div id="sidebar-menu">
              <ul className="metismenu list-unstyled mt-4" id="side-menu">
                {/* Conditionally render menu based on active dashboard tab */}
                {dashboardTab === "ESG" ? renderESGMenu() : renderCategoryMenu()}

                {isAdminLoggedIn && (
                  <>
                    {Object.entries(routeMapping).map(([key, value]) =>
                      key === "Assign" ? null : (
                        <li
                          key={key}
                          onClick={() => {
                            navigate(value.path);
                          }}
                          style={{ cursor: "pointer" }}
                        >
                          <span>{value.icon}</span>
                          {key}
                        </li>
                      )
                    )}
                  </>
                )}
              </ul>
            </div>
          </div>
        </div>
      </>
    );
  }

  // Admin sidebar (unchanged)
  return (
    <div className="vertical-menu">
      <div data-simplebar className="h-100">
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled mt-5" id="side-menu">
            <li className="menu-title">Menu</li>
            <li>
              <Link to="/admin/dashboard" className="waves-effect">
                <i className="bx bx-home-circle"></i>
                <span>Dashboard</span>
              </Link>
            </li>
            <li>
              <Link to="/admin/categories" className="waves-effect">
                <i className="bx bx-detail"></i>
                <span>Category</span>
              </Link>
            </li>
            <li>
              <Link to="/admin/subcategories" className="waves-effect">
                <i className="bx bx-file"></i>
                <span>Sub Category</span>
              </Link>
            </li>
            <li>
              <Link to="/admin/kpi" className="waves-effect">
                <i className="bx bx-receipt"></i>
                <span>KPI</span>
              </Link>
            </li>
            <li>
              <Link to="/admin/company" className="waves-effect">
                <i className="bx bx-store"></i>
                <span>Companies</span>
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default observer(Sidebar);